import {ChangeDetectorRef, Injectable} from "@angular/core";
import {Modal, ModalService} from "./modal.service";
import {Api} from "../../common/services/api.service";
import {Api3Service} from "../../common/services/api3.service";
import {SpinnerService} from "../../common/services/spinner.service";
import {CommonFormComponent} from "../../common/components/form";
import {LabelModalComponent} from "../components/common/components/custom-labels";
import {AppStateService} from "../../common/services/app-state.service";


@Injectable()
export class LabelPrintService {


    private labels: any[] = [];

    public constructor(
        private modalService: ModalService,
        private api3Service: Api3Service,
        private spinnerService: SpinnerService,
    ) {
    }

    private async getLabels(type: string): Promise<any> {
        this.spinnerService.show();
        const {data}: Api.IResponse = await this.api3Service
            .get(`${AppStateService.getState().section}/custom-labels`, {
                type,
                data_structure: "select",
            });
        this.spinnerService.hide();

        if (data) {
            this.labels = data;
        }
    }

    private async selectLabel(): Promise<any> {
        const res: Modal.IResponse = await this.modalService.open(CommonFormComponent, {
            formConfig: {
                name: "Select label type",
                description: "",
                fields: [
                    {
                        label: "Type",
                        name: "label_id",
                        size: "full",
                        type: "select",
                        values: this.labels,
                        selected_on_top: false,
                        required: true
                    },
                ],
            },
            noReset: true,
        });
        if (!res?.value?.label_id) {
            return null;
        }

        return res.value.label_id;
    }

    public async printLabel(
        type: string,
        modelsIds: number[],
        allowEdit: boolean = false,
        editData: any = null
    ): Promise<any> {
        await this.getLabels(type);

        if (this.labels.length == 0) {
            alert("No item label templates found. Please create one in the settings");
            return;
        }

        let label_id: number = this.labels[0].value;

        if (this.labels.length > 1) {
            label_id = await this.selectLabel();
        }

        if (!label_id) {
            return;
        }

        const res: Modal.IResponse = await this.modalService.open(LabelModalComponent, {
            label_id,
            type,
            ids: modelsIds,
            show_edit_button: allowEdit,
            data: editData
        });

        return res && res.name === "edit";
    }
}
